import { CERTIFIED_METRICS } from "portal/utils/certifiedMetrics";
import {
  CertifiedMetricRow,
  PROCESSED_METRICS_BRAND,
  type ProcessedMetrics,
} from "./table.types";
import { DailyMetricResponse } from "protos/portal/metrics";

/**
 * Turns raw certified API metrics into `ProcessedMetrics` by applying each
 * certified metric's formatter exactly once (required because getters are
 * not idempotent).
 */
export const getMetricValues = (
  metrics: CertifiedMetricRow | undefined
): ProcessedMetrics => {
  // Two kinds of properties:
  //  (a) non-metric properties like "db";
  //  (b) metrics that exist on the `metrics` response
  // Clone to get (a) (as well as (b)), then process to handle unit conversions and
  //  make sure data use matches other metric locations.
  // `fromPartial` fills in defaults (e.g. `notWeedingWeeds: 0`) that some
  // metric getters depend on but which are absent on `JobMetricResponse`.
  if (!metrics) {
    return {
      [PROCESSED_METRICS_BRAND]: true,
      ...DailyMetricResponse.fromPartial({}),
    };
  }
  const base = DailyMetricResponse.fromPartial(metrics);
  const result: Partial<ProcessedMetrics> = {
    [PROCESSED_METRICS_BRAND]: true,
    ...base,
  };
  for (const metric of CERTIFIED_METRICS) {
    const key = metric.id;
    result[key] = metric.getValue(base) as any;
  }
  return result as ProcessedMetrics;
};
